import { useQuery } from '@tanstack/react-query'
import { AsyncSelect as AsyncSelectVNW } from 'vnetwork-ui'
import { AsyncSelectProps } from 'vnetwork-ui/dist/components/AsyncSelect'

const AsyncSelect = <T extends object>(
    props: Omit<AsyncSelectProps<T>, 'useQuery'>
) => {
    // @ts-ignore
    return <AsyncSelectVNW {...props} useQuery={useQuery} />
}

export default AsyncSelect
